var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var _a;
import Vue from 'vue';
import axios from 'axios';
import { Prop, Component } from 'vue-property-decorator';
import { Dialog, Button } from 'element-ui';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.min.css';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalShow = false;
        _this.previews = {};
        _this.previewStyle = {};
        _this.imgUrl = '';
        _this.width = 0;
        _this.height = 0;
        _this.myCropper = null;
        _this.previewId = 'cropperImgPreview';
        _this.imgId = 'cropperImg';
        _this.loading = false;
        _this.option = {
            img: '',
            outputSize: 1,
            outputType: 'png'
        };
        return _this;
    }
    default_1.prototype.realTime = function (data) {
        console.log('realTime>>>', data);
        var preview = data;
        var h = 0.5;
        var w = 0.2;
        this.previewStyle = {
            width: preview.w + "px",
            height: preview.h + "px",
            overflow: "hidden",
            margin: "0",
            zoom: h
        };
        this.previews = data;
    };
    default_1.prototype.show = function (url) {
        var _this = this;
        this.option.img = url;
        this.modalShow = true;
        this.$nextTick(function () {
            var dom = document.getElementById(_this.imgId);
            if (_this.myCropper) {
                _this.myCropper.destroy();
            }
            dom.addEventListener('crop', function (event) {
                var _a = event.detail, width = _a.width, height = _a.height;
                _this.width = Math.ceil(width);
                _this.height = Math.ceil(height);
            });
            _this.myCropper = new Cropper(dom, {
                preview: "#" + _this.previewId,
                checkCrossOrigin: true,
                minCanvasHeight: 100,
                minCanvasWidth: 100,
                minContainerHeight: 100,
                minContainerWidth: 100,
            });
            _this.myCropper.replace(url);
        });
    };
    default_1.prototype.rotateLeft = function () {
        this.myCropper.rotate(-90);
    };
    default_1.prototype.rotateRight = function () {
        this.myCropper.rotate(90);
    };
    default_1.prototype.scale = function (d) {
        this.myCropper["scale" + d](-this.myCropper.getData()["scale" + d]);
    };
    default_1.prototype.close = function () {
        this.modalShow = false;
        this.loading = false;
    };
    default_1.prototype.confirm = function () {
        var _this = this;
        this.loading = true;
        try {
            this.myCropper && this.myCropper.getCroppedCanvas().toBlob(function (blob) {
                var formData = new FormData();
                formData.append('file', blob);
                axios.post(_this.action, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(function (res) {
                    if (res.data.success) {
                        _this.$emit('on-crop', res.data.data.full_path, _this.option.img);
                        _this.close();
                    }
                    else {
                        _this.$message.error(res.data.msg || '操作失败');
                    }
                    _this.loading = false;
                }, function () {
                    _this.loading = false;
                });
            });
        }
        catch (e) {
            this.loading = false;
        }
    };
    __decorate([
        Prop({
            default: "/supplierapi/upload",
            type: String
        })
    ], default_1.prototype, "action", void 0);
    default_1 = __decorate([
        Component({
            components: (_a = {},
                _a[Button.name] = Button,
                _a[Dialog.name] = Dialog,
                _a)
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
